import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { Row, Col, Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DataGrid from "../DataGrid";
import ViewAccountList from "./ViewAccountList.js";
import UpdateAccount from "./UpdateAccount.js";
import OrgAccount from "./OrgAccount.js";
import { convertDate, shouldFilterUsername } from "../../helpers/util_helper";
import {
  getListOfAccts,
  clearAllOrgAccountMessages,
  getPricingInfo,
  clearAllAwsAccMessages,
} from "../../store/actions";
import { clearAllAccountConfigurationMessages } from "../../store/accountConfiguration/accountConfigurationSlice";
import { clearOrganizationalUnits } from "../../store/multiAccountOnboard/multiAccountSlice";
import { connect } from "react-redux";
import AddOnsManagement from "./AddonsManagement";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { enqueueSnackbar } from "notistack";

import UpdateIamRole from "./UpdateIamRole.js";
import getUserRole from "./../../helpers/jwt-token-access/userRole.js";
import SubscriptionModal from "./SubscriptionManagement/SubscriptionModal.js";
import { Tooltip, IconButton, Typography, Box, Divider, List, ListItem, ListItemText, Paper, Alert } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import SettingsIcon from "@mui/icons-material/Settings";
import styles from "./style.module.css";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MultipleAccountsForm from "./MultipleAccountsForm";
import { getAccountCloudType } from "../../CloudProviderContext";
import CloudProviderMark from "../Common/CloudProviderMark";

const allowedRoles = ["Administrator"];

const activeColor = "#4caf50"; // Green
const inactiveColor = "#f44336"; // Red
const disabledAddonsColor = "#5f9ed1"; // Blue
const expiredColor = "#7a0709"; // Brown

const InactiveAccountIcon = () => (
  <Tooltip title="Activate Account" placement="top">
    <IconButton size="small" className={styles.lockButton}>
      <LockOpenIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

const LegendItem = ({ color, description }) => (
  <Box display="flex" alignItems="center" mb={1}>
    <FiberManualRecordIcon
      sx={{ color: color, marginRight: 1, fontSize: 12 }}
    />
    <Typography variant="body2">{description}</Typography>
  </Box>
);

const Legends = () => {
  return (
    <Box sx={{ marginTop: "1rem" }}>
      <LegendItem
        color={activeColor}
        description="Active Account: All modules (Cloud Event, FinOps, Cost Optimization) enabled"
      />
      <LegendItem
        color={inactiveColor}
        description={
          <>
            Inactive Account: Account inactive due to incorrect External ID or
            cross-account role missing. Please click on the{" "}
            <LockOpenIcon sx={{ color: "orange" }} fontSize="small" /> and
            follow the account pairing guide.
          </>
        }
      />
      <LegendItem
        color={disabledAddonsColor}
        description="Active Account: One or more modules (Cloud Event, FinOps, Cost Optimization) disabled"
      />
      <LegendItem
        color={expiredColor}
        description="Subscription Expired: Please renew your subscription to enable features."
      />
    </Box>
  );
};

class DataGridWrapper extends React.Component {
  shouldComponentUpdate(nextProps) {
    //Working
    // Re-render if new account Added
    if (this.props.data.rows.length !== nextProps.data.rows.length) {
      return true; // Allow the component to update if 'data' prop has changed
    }
    // console.log("shouldComponentUpdate, nextProps", nextProps);
    // console.log("shouldComponentUpdate, this.props.data", this.props.data);

    for (const prevAcct of this.props.data.rows) {
      const nextAcct = nextProps.data.rows.find(
        (acct) => acct.accountCode === prevAcct.accountCode
      );
      console.log("shouldComponentUpdate, nextAcct : ", nextAcct);
      if (prevAcct.last_modified !== nextAcct.last_modified) {
        return true;
      }
    }

    console.log("No Update needed")
    return false; // Prevent the component from updating
    //following is for testing
    // return true; // Prevent the component from updating
  }

  render() {
    return (
      <>
        <DataGrid {...this.props} />
      </>
    );
  }
}

class AccountDetailPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      modal_static: false,
      modal_addons: false,
      editAcctModal: false,
      editRoleModal: false,
      notifyDelete: false,
      isOpen: false,
      tooltipOpen: false,
      numAccounts: this.props.licensing.numAccounts,
      isLicensingInfoOpen: false,
      selectedLicense: null,
      accountInformation: null,
      licenseData: null,
      accounts: null,
      editAccountCode: null,
      addAccountTab: '1',
      currentStep: 1, // Track current step for side panel
      sidePanelOpen: true, // Track side panel visibility
      selectedAccountType: "", // Cloud provider selected in Add Account Step 1
      showMultipleAccountsTab: false, // AWS-only; shown after advancing past cloud select
      azureLighthouseJson: null, // Lighthouse template JSON for Azure pairing side panel
      lighthouseCopySuccess: false,
      azureFetchDetailsComplete: false, // Show Step 5 in side panel after successful Fetch
    };
    this.multipleAccountsFormRef = React.createRef();
  }

  handleStepChange = (step) => {
    this.setState((prevState) => {
      const next = { currentStep: step };
      // Only update multi-account tab visibility from the Add Account wizard step
      if (prevState.addAccountTab === "1") {
        if (prevState.selectedAccountType === "AWS") {
          next.showMultipleAccountsTab = true;
        }
        if (step === 1 && prevState.selectedAccountType !== "AWS") {
          next.showMultipleAccountsTab = false;
        }
      }
      return next;
    });
  };

  handleAccountTypeChange = (accountType) => {
    this.setState((prevState) => ({
      selectedAccountType: accountType,
      ...(accountType === "AWS"
        ? { showMultipleAccountsTab: true }
        : {
            showMultipleAccountsTab: false,
            ...(prevState.addAccountTab === "2"
              ? {
                  addAccountTab: "1",
                  currentStep:
                    prevState.currentStep >= 1 ? prevState.currentStep : 1,
                }
              : {}),
          }),
    }));
  };

  handleSidePanelClose = () => {
    this.setState({ sidePanelOpen: false });
  };

  handleSidePanelOpen = () => {
    this.setState({ sidePanelOpen: true });
  };

  handleAzureLighthouseJsonChange = (jsonText) => {
    this.setState({
      azureLighthouseJson: jsonText || null,
      lighthouseCopySuccess: false,
    });
  };

  handleAzureFetchDetailsComplete = (complete) => {
    this.setState({ azureFetchDetailsComplete: !!complete });
  };

  handleCopyLighthouseJson = () => {
    const { azureLighthouseJson } = this.state;
    if (!azureLighthouseJson) return;
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(azureLighthouseJson).then(() => {
        this.setState({ lighthouseCopySuccess: true });
        setTimeout(
          () => this.setState({ lighthouseCopySuccess: false }),
          3000
        );
      });
    }
  };

  handleDownloadLighthouseJson = () => {
    const { azureLighthouseJson } = this.state;
    if (!azureLighthouseJson) return;
    const blob = new Blob([azureLighthouseJson], {
      type: "application/json;charset=utf-8",
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "lighthouse-pairing-template.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };

  getAddAccountStepInfo = () => {
    const { currentStep, addAccountTab, selectedAccountType } = this.state;

    if (addAccountTab === "1") {
      if (currentStep < 1 || currentStep > 5) return null;
      return OrgAccount.getStepInformation(currentStep, selectedAccountType);
    }

    if (addAccountTab === "2") {
      if (currentStep < 1 || currentStep > 2) return null;
      return MultipleAccountsForm.getStepInformation(currentStep);
    }

    return null;
  };

  renderCollapsedSidePanelTab = () => {
    const { isOpen, addAccountTab } = this.state;
    if (!isOpen || (addAccountTab !== "1" && addAccountTab !== "2")) {
      return null;
    }

    return (
      <Tooltip title="Show guide" placement="left" arrow>
        <Box
          component="button"
          type="button"
          onClick={this.handleSidePanelOpen}
          aria-label="Show account setup guide"
          sx={{
            position: "fixed",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1051,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.75,
            width: 40,
            minHeight: 120,
            px: 0.5,
            py: 1.5,
            border: "1px solid #e0e0e0",
            borderRight: "none",
            borderRadius: "10px 0 0 10px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
            cursor: "pointer",
            color: "#193A6F",
            transition: "background-color 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              backgroundColor: "#f8fafc",
              boxShadow: "0 6px 20px rgba(0, 0, 0, 0.16)",
            },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: 22 }} />
          <Typography
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              fontSize: "0.75rem",
              fontWeight: 600,
              letterSpacing: "0.06em",
              color: "#334155",
              userSelect: "none",
            }}
          >
            Guide
          </Typography>
        </Box>
      </Tooltip>
    );
  };

  renderSidePanel = () => {
    const {
      currentStep,
      isOpen,
      addAccountTab,
      sidePanelOpen,
      selectedAccountType,
      azureLighthouseJson,
      lighthouseCopySuccess,
      azureFetchDetailsComplete,
    } = this.state;
    
    // Show side panel for both tabs when modal is open
    if (!isOpen || (addAccountTab !== "1" && addAccountTab !== "2")) {
      return null;
    }

    if (!sidePanelOpen) {
      return this.renderCollapsedSidePanelTab();
    }

    const stepInfo = this.getAddAccountStepInfo();
    if (!stepInfo || !stepInfo.steps || stepInfo.steps.length === 0) {
      return null;
    }

    const showLighthouseEditor =
      addAccountTab === "1" &&
      selectedAccountType === "AZURE" &&
      currentStep === 3 &&
      !!azureLighthouseJson;

    return (
      <Box
          sx={{
            position: "fixed",
            right: 0,
            top: 0,
            height: "100vh",
            width: { xs: 320, sm: 380, md: 420, lg: 480 },
            backgroundColor: "#fff",
            boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.3)",
            border: "1px solid #e0e0e0",
            zIndex: 1051,
            overflow: showLighthouseEditor ? "hidden" : "auto",
          }}
        >
          <Paper
            elevation={0}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 3,
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Box sx={{ flex: 1, pr: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: "18px",
                    mb: 1,
                  }}
                >
                  {stepInfo.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "13px", lineHeight: 1.4 }}
                >
                  {addAccountTab === '1'
                    ? (currentStep === 1
                        ? "Choose AWS or Azure to begin adding an account."
                        : `Follow these steps to add ${
                            selectedAccountType === "AZURE" ? "an Azure" : selectedAccountType === "AWS" ? "an AWS" : "a cloud"
                          } account.`)
                    : "Follow these steps to onboard linked accounts."}
                </Typography>
              </Box>
              <Tooltip title="Hide guide" placement="left" arrow>
                <IconButton
                  onClick={this.handleSidePanelClose}
                  aria-label="Hide account setup guide"
                  sx={{
                    color: "#666",
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                      color: "#333",
                    },
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Content */}
            <Box
              sx={{
                flex: 1,
                p: 2,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                overflow: showLighthouseEditor ? "hidden" : "auto",
              }}
            >
              <List sx={{ p: 0, flexShrink: 0 }}>
                {(() => {
                  let mainStepCounter = 0;
                  return stepInfo.steps.map((step, index) => {
                    const isSubStep = step.startsWith("  ");
                    const stepText = isSubStep ? step.trim() : step;
                    // Check for main steps: not a sub-step and not starting with lowercase letter, uppercase letter, or Roman numeral
                    // Tab 1 uses Roman numerals (i, ii, iii, iv), Tab 2 uses uppercase letters (A, B, C) and Roman numerals (I, II, III)
                    const isMainStep = !isSubStep && 
                      !stepText.match(/^[a-z]\./) && 
                      !stepText.match(/^[A-Z]\./) && 
                      !stepText.match(/^[ivx]+\./) &&
                      !stepText.match(/^[IVX]+\./);
                    
                    if (isMainStep) {
                      mainStepCounter++;
                    }
                    
                    const stepNumber = isMainStep ? mainStepCounter : null;
                    
                    return (
                    <React.Fragment key={index}>
                      <ListItem 
                        sx={{ 
                          px: 0, 
                          py: 0.5, 
                          alignItems: "flex-start",
                          pl: isSubStep ? 4 : 0,
                        }}
                      >
                        {isMainStep && stepNumber && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              backgroundColor: "#f0f7ff",
                              border: "2px solid #1976d2",
                              mr: 2,
                              mt: 0.5,
                              flexShrink: 0,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#1976d2",
                                fontWeight: 600,
                                fontSize: "14px",
                              }}
                            >
                              {stepNumber}
                            </Typography>
                          </Box>
                        )}
                        {isSubStep && (
                          <Box sx={{ width: 32, mr: 2, flexShrink: 0 }} />
                        )}
                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                fontSize: "13px",
                                lineHeight: 1.6,
                                whiteSpace: "pre-line",
                              }}
                            >
                              {stepText}
                            </Typography>
                          }
                        />
                      </ListItem>
                      {index < stepInfo.steps.length - 1 && 
                       !stepInfo.steps[index + 1].startsWith("  ") && 
                       !stepInfo.steps[index + 1].trim().match(/^[a-z]\./) &&
                       !stepInfo.steps[index + 1].trim().match(/^[A-Z]\./) &&
                       !stepInfo.steps[index + 1].trim().match(/^[ivx]+\./) &&
                       !stepInfo.steps[index + 1].trim().match(/^[IVX]+\./) && (
                        <Divider
                          sx={{
                            ml: 6,
                            mr: 2,
                            borderColor: "#e0e0e0",
                          }}
                        />
                      )}
                    </React.Fragment>
                    );
                  });
                })()}
                {showLighthouseEditor && (
                  <>
                    <Divider
                      sx={{
                        ml: 6,
                        mr: 2,
                        my: 0.5,
                        borderColor: "#e0e0e0",
                      }}
                    />
                    <ListItem
                      sx={{
                        px: 0,
                        py: 0.5,
                        alignItems: "flex-start",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          backgroundColor: "#f0f7ff",
                          border: "2px solid #1976d2",
                          mr: 2,
                          mt: 0.5,
                          flexShrink: 0,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#1976d2",
                            fontWeight: 600,
                            fontSize: "14px",
                          }}
                        >
                          4
                        </Typography>
                      </Box>
                      <ListItemText
                        primary={
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              fontSize: "13px",
                              lineHeight: 1.6,
                            }}
                          >
                            Azure Light House Pairing Template
                          </Typography>
                        }
                      />
                    </ListItem>
                  </>
                )}
              </List>
              {showLighthouseEditor && (
                <Box
                  sx={{
                    mt: 1.5,
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#1e1e1e",
                    borderRadius: "6px",
                    border: "1px solid #333",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 0.25,
                      px: 0.5,
                      pt: 0.25,
                      flexShrink: 0,
                      backgroundColor: "#1e1e1e",
                    }}
                  >
                    <Tooltip
                      title={
                        lighthouseCopySuccess ? "Copied" : "Copy JSON"
                      }
                    >
                      <IconButton
                        size="small"
                        aria-label="Copy Lighthouse JSON"
                        onClick={this.handleCopyLighthouseJson}
                        sx={{ color: "#d4d4d4" }}
                      >
                        <ContentCopyIcon
                          fontSize="small"
                          color={
                            lighthouseCopySuccess ? "primary" : "inherit"
                          }
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Download JSON">
                      <IconButton
                        size="small"
                        aria-label="Download Lighthouse JSON"
                        onClick={this.handleDownloadLighthouseJson}
                        sx={{ color: "#d4d4d4" }}
                      >
                        <DownloadIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Box
                    component="pre"
                    sx={{
                      m: 0,
                      px: 1.5,
                      pb: 1.5,
                      pt: 0.5,
                      flex: 1,
                      minHeight: 0,
                      overflow: "auto",
                      color: "#d4d4d4",
                      fontFamily:
                        "Consolas, Monaco, 'Courier New', monospace",
                      fontSize: "12px",
                      lineHeight: 1.5,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {azureLighthouseJson}
                  </Box>
                </Box>
              )}
              {azureFetchDetailsComplete && (
                <List sx={{ p: 0, flexShrink: 0, mt: showLighthouseEditor ? 1 : 0 }}>
                  <Divider
                    sx={{
                      ml: 6,
                      mr: 2,
                      my: 0.5,
                      borderColor: "#e0e0e0",
                    }}
                  />
                  <ListItem
                    sx={{
                      px: 0,
                      py: 0.5,
                      alignItems: "flex-start",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#f0f7ff",
                        border: "2px solid #1976d2",
                        mr: 2,
                        mt: 0.5,
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#1976d2",
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        5
                      </Typography>
                    </Box>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "13px",
                            lineHeight: 1.6,
                          }}
                        >
                          Verify the details and hit Submit to create your new
                          Azure Account
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              )}
            </Box>
          </Paper>
        </Box>
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return { ...prevState, numAccounts: nextProps.licensing.numAccounts };
  }

  componentDidMount() {
    document
      .getElementsByClassName("pagination")[0]
      .classList.add("pagination-rounded");
    const [searchBoxItem, dataTableRef] =
      document.getElementsByClassName("mdb-datatable")[0].children;
    if (
      searchBoxItem.getElementsByClassName("mdb-datatable-filter").length > 0
    ) {
      searchBoxItem.setAttribute(
        "style",
        "justify-content: flex-end !important"
      );

      const [dataTableTHead] = dataTableRef.getElementsByTagName("thead");
      dataTableTHead.setAttribute(
        "style",
        "color: #fff !important; background-color: #343a40 !important;"
      );
      const reactDynamicTag = document.createElement("div");
      reactDynamicTag.setAttribute("id", "userConfigBtnHolder");
      reactDynamicTag.setAttribute("class", "pt-1");
      searchBoxItem.append(reactDynamicTag);

      const userRole = getUserRole();
      ReactDOM.render(
        this.getAddButton(userRole),
        document.getElementById("userConfigBtnHolder")
      );
    }
  }

  componentDidUpdate(prevProps) {
    const userRole = getUserRole();
    ReactDOM.render(
      this.getAddButton(userRole),
      document.getElementById("userConfigBtnHolder")
    );
    if (prevProps.accounts !== this.props.accounts) {
      this.setState({ accounts: this.props.accounts });
    }
    if (this.props.pricingInfo && !this.state.licenseData) {
      this.setState({
        licenseData: this.props.pricingInfo["Subscription Model"],
      });
    }

    // //Display notification
    // if(prevProps.postAwsAccMessage !== this.props.postAwsAccMessage && this.props.postAwsAccMessage) {
    //   console.log("this.props.postAwsAccMessage : ", this.props.postAwsAccMessage);
    //   enqueueSnackbar(this.props.postAwsAccMessage, { variant: "success" });
    //   this.props.clearAllAwsAccMessages();
    // }
    // if(prevProps.postAwsAccError !== this.props.postAwsAccError && this.props.postAwsAccError) {
    //   enqueueSnackbar(this.props.postAwsAccError, { variant: "error" });
    //   this.props.clearAllAwsAccMessages();
    // }
  }


  getAddButton = (userRole) => {
    const filtered =
      this.props.accounts &&
      this.props.accounts.filter(
        (x) =>
          !x.accountNumber.includes("INIT00000001") &&
          !x.accountNumber.includes("TEST") &&
          x.accountNumber.length === 12
      );
    if (
      this.props.orgLicensing?.data?.licenseName !== "AwsMarketPlaceLicense"
    ) {
      return (
        <div className="ml-2" style={{ marginRight: 10, display: 'flex', gap: '10px' }}>
          <Button
            style={{
              textAlign: "right",
              backgroundColor: "#F98125",
              float: "right",
              borderColor: "#fff",
            }}
            size="sm"
            onClick={this.openModal}
            className={`btn mb-2 ${
              this.props.roleAccess >= 0 ? " btn-success" : ""
            }`}
            disabled={
              this.props.roleAccess < 0 ||
              filtered.length >= this.state.numAccounts ||
              !allowedRoles.includes(userRole) || this.props.orgLicensing?.data?.licenseName === "CUSTOMER"
            }
          >
            <span id="AddAccountsBtn">
              <i className="mdi mdi-plus mr-2"></i>
              {this.props.isAzureView ? "Pair Subscription" : "Pair Account"}
            </span>
          </Button>
          
        </div>
      );
    }
  };

  toggleTab = (tab) => {
    if (this.state.addAccountTab !== tab) {
      this.setState({ addAccountTab: tab, currentStep: 1 });
    }
  };

  setNotifyDelete(status, row) {
    this.setState({
      ...this.state,
      notifyDelete: status,
      notifyDeleteRow: row,
    });
  }

  newAccountAdded = (receivedState) => {
    if (
      receivedState &&
      Array.isArray(receivedState) &&
      receivedState.length > 0
    ) {
      receivedState = receivedState.filter(
        (x) =>
          !x.accountNumber.includes("INIT00000001") &&
          !x.accountNumber.includes("TEST") &&
          x.accountNumber.length === 12
      );
      const receivedStateLength = receivedState.length;
      if (this.props.accounts.length !== receivedStateLength) {
        this.setState({ accounts: this.props.accounts });
        console.log(
          "Calling getListOfAccts() from AccountDetailPolicy, newAccountAdded"
        );
        this.props.dispatchGetListOfAccts();
      }
    } else {
      console.error("receivedState is either null, not an array, or empty");
    }
  };

  updateData = () => {
    console.log("Update Data Called ***");
    if (this.props.postAccountConfigurationMessage) {
      console.log(
        "Calling getListOfAccts() from AccountDetailPolicy, updateData"
      );
      this.props.dispatchGetListOfAccts();
    }
    if (
      this.props.postAccountConfigurationMessage ||
      this.props.postAccountConfigurationError
    ) {
      this.props.clearAllAccountConfigurationMessages();
    }
  };

  closeModal = () => {
    // Stop polling if the ref exists
    if (this.multipleAccountsFormRef.current && 
        this.multipleAccountsFormRef.current.treeSelectorRef && 
        this.multipleAccountsFormRef.current.treeSelectorRef.current && 
        typeof this.multipleAccountsFormRef.current.treeSelectorRef.current.stopPolling === 'function') {
      this.multipleAccountsFormRef.current.treeSelectorRef.current.stopPolling();
    }

    // Only dispatch if we're closing addons modal and changes were made
    if (this.state.modal_addons && this.props.postAccountConfigurationMessage) {
      this.props.dispatchGetListOfAccts();
    }
    
    // Reset modal state and refresh datagrid
    this.setState({
      ...this.state,
      modal_static: false,
      modal_addons: false,
      editAcctModal: false,
      editRoleModal: false,
      isOpen: false,
      addAccountTab: '1', // Reset to first tab
      currentStep: 1, // Reset step for side panel
      sidePanelOpen: true, // Reset side panel to open when modal reopens
      selectedAccountType: "",
      showMultipleAccountsTab: false,
      azureLighthouseJson: null,
      lighthouseCopySuccess: false,
      azureFetchDetailsComplete: false,
    });
    
    // Refresh the datagrid to show latest data
    this.props.dispatchGetListOfAccts();
    
    // Clear all messages
    this.props.clearAllOrgAccountMessages();
    
    // Clear organizational units state to reset the modal completely
    this.props.dispatchClearOrganizationalUnits();
  };

  openModal = () => {
    const initialAccountType = this.props.isAzureView ? "AZURE" : "AWS";
    this.setState({
      isOpen: true,
      sidePanelOpen: true,
      selectedAccountType: initialAccountType,
      showMultipleAccountsTab: initialAccountType === "AWS",
      azureLighthouseJson: null,
      lighthouseCopySuccess: false,
      azureFetchDetailsComplete: false,
    });
  };

  closeModalview = () => this.setState({ isOpen: false });
  setTooltipOpen = (state) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        tooltipOpen: state,
      };
    });
  };

  openLicensingInfoModal = (selectedLicense, accountInformation) => {
    this.setState({
      isLicensingInfoOpen: true,
      selectedLicense: selectedLicense,
      accountInformation: accountInformation,
    });
  };
  closeLicensingInfoModal = () => {
    this.setState({
      isLicensingInfoOpen: false,
      licenseData: null,
      selectedLicense: null,
      accountInformation: null,
    });
  };

  handleUpgradeClick = (successMessage) => {
    enqueueSnackbar(successMessage, { variant: "success" });
    console.log(
      "Calling getListOfAccts() from AccountDetailPolicy, handleUpgradeClick"
    );
    this.props.dispatchGetListOfAccts();
    this.setState({ accounts: this.props.accounts });
  };

  handleAddonsUpgrade = (successMessage) => {
    console.log("Upgrade process initiated with Addons:");
    console.log("Before enqueueSnackbar");
    enqueueSnackbar(successMessage, { variant: "success" });
    console.log("After enqueueSnackbar");
    console.log(
      "Calling getListOfAccts() from AccountDetailPolicy, handleAddonsUpgrade"
    );
    this.props.dispatchGetListOfAccts();
    this.setState({ accounts: this.props.accounts });
    console.log("After Update");
  };

  handleAccountsAdded = () => {
    this.props.dispatchGetListOfAccts();
    this.props.dispatchClearOrganizationalUnits();
    this.closeModal();
  };

  getAccountStatusColor = (acct) => {
    if (acct.status === "ACTIVE" && acct.subscription_status !== "expired") {
      return acct.subscription?.addons === null ||
        acct.subscription?.addons?.length < 3 ||
        acct.subscription?.addons?.filter((addon) => addon.enabled).length < 3
        ? disabledAddonsColor
        : activeColor;
    } else if (acct.subscription_status === "expired") {
      return expiredColor;
    } else if (acct.status === "INACTIVE") {
      return inactiveColor;
    }
  };

  render() {
    console.log("AccountDetailPolicy is rendered");
    const userRole = getUserRole();
    const filtered = this.props.accounts;
    const editAcct = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    );
    const complianceAddOns = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    )?.complianceAddOns;
    const addOns = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    )?.subscription?.addons;

    const columns = [
        {
          label: "",
          field: " ",
          sort: "disabled",
        },
        {
          label: "Cloud Accounts",
          field: "id",
          sort: "asc",
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
        },
        {
          label: (
            <Box display="flex" alignItems="center">
              Account Type
            </Box>
          ),
          field: "accountType",
          sort: "asc",
        },
        {
          label: (
            <Box display="flex" alignItems="center">
              Subscription
              <Tooltip
                title="Click on a subscription below to view details"
                placement="top"
              >
                <IconButton size="small" style={{ color: "white" }}>
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          ),
          field: "subscription",
          sort: "asc",
        },
        {
          label: (
            <div>
              Add-Ons
              <Tooltip title="Click on the Add-Ons below to view or manage them">
                <IconButton size="small" style={{ color: "white" }}>
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          ),
          field: "addons",
          sort: "disabled",
        },
        {
          label: (
            <div>
              Users
              <Tooltip title="Click below to see the users who have access to the selected account">
                <IconButton
                  size="small"
                  style={{ marginLeft: "5px", color: "white" }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          ),
          field: "user",
          sort: "disabled",
        },
        {
          label: "Resource Group",
          field: "group",
          sort: "asc",
        },
        {
          label: "Date Added",
          field: "date_added",
          sort: "asc",
        },
        {
          label: "Date Modified",
          field: "date_modified",
          sort: "asc",
        },
        {
          label: "Action",
          field: "action",
          sort: "disabled",
          className: "action-column",
        },
      ];

    const data = {
      columns,
      rows:
        filtered &&
        filtered
          .sort((a, b) => {
            // Sort master accounts first
            if (a.is_master && !b.is_master) return -1;
            if (!a.is_master && b.is_master) return 1;
            // If both are master or both are not master, sort by account number
            return a.accountNumber.localeCompare(b.accountNumber);
          })
          .map((acct) => {
          return {
            id: (
              <Box display="flex" alignItems="center">
                <FiberManualRecordIcon
                  sx={{
                    color: this.getAccountStatusColor(acct),
                    fontSize: 12, // Adjust size to fit your design
                    marginRight: "8px",
                  }}
                />
                {acct.accountNumber}
                {acct.is_master && (
                  <Box
                    component="span"
                    sx={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "0.7rem",
                      fontWeight: "bold",
                      padding: "2px 6px",
                      borderRadius: "12px",
                      marginLeft: "8px",
                      lineHeight: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      height: "16px",
                    }}
                  >
                    Master
                  </Box>
                )}
              </Box>
            ),
            accountCode: `${acct.accountCode}`,
            name: `${acct.accountName}`,
            accountType: (
              <CloudProviderMark
                provider={getAccountCloudType(acct)}
                sx={{ mr: 0 }}
              />
            ),
            group: `${acct.accountResourceGroups}`
              ? `${acct.accountResourceGroups[0].resourcename}`
              : "Default",
            user: (
              <Link
                to="#"
                onClick={() => {
                  // Store user list in state only when modal opens
                  const filteredUsers = acct.listusr.filter((user) => 
                    user.isActivated && 
                    !shouldFilterUsername(user.userName)
                  );
                  this.setState({
                    ...this.state,
                    modal_static: true,
                    accountCode: acct.accountCode,
                    accountNumber: acct.accountNumber,
                    userList: filteredUsers,
                  });
                }}
              >
                <div className="badge badge-pill badge-light">
                  {
                    acct.listusr.filter(
                      (user) =>
                        user.isActivated &&
                        !user.email.includes(process.env.REACT_APP_EMAIL_DOMAIN) &&
                        !shouldFilterUsername(user.userName)
                    ).length
                  }
                </div>
              </Link>
            ),
            addons: (
              <div>
                {acct.status === "ACTIVE" ? (
                  <Link
                    to="#"
                    onClick={() => {
                      this.setState({
                        ...this.state,
                        modal_addons: true,
                        accountCode: acct.accountCode,
                        accountNumber: acct.accountNumber,
                        editAccountCode: acct.accountCode,
                      });
                    }}
                  >
                    <div
                      className="badge badge-pill badge-light d-inline-flex align-items-center"
                      style={{ gap: 4 }}
                    >
                      <SettingsIcon sx={{ fontSize: 14, color: "rgba(0,0,0,0.55)", flexShrink: 0 }} />
                      {acct.complianceAddOns.filter((addOn) => addOn.enabled)
                        .length +
                        acct.subscription.addons.filter(
                          (addOn) => addOn.enabled
                        ).length}
                    </div>
                  </Link>
                ) : (
                  <div>
                    <div
                      className="badge badge-pill badge-light d-inline-flex align-items-center"
                      style={{ gap: 4 }}
                    >
                      <SettingsIcon sx={{ fontSize: 14, color: "rgba(0,0,0,0.55)", flexShrink: 0 }} />
                      {acct.complianceAddOns.filter((addOn) => addOn.enabled)
                        .length +
                        acct.subscription.addons.filter(
                          (addOn) => addOn.enabled
                        ).length}
                    </div>
                  </div>
                )}
              </div>
            ),
            date_added: convertDate(
              acct.subscription_modified_date
                ? acct.subscription_modified_date
                : acct.createdDate
            ),
            date_modified: convertDate(`${acct.lastModifiedDate}`),
            last_modified: `${acct.lastModifiedDate}`,
            subscription: (
              <div>
                <Link
                  to="#"
                  onClick={() => {
                    this.openLicensingInfoModal(acct.subscription.name, acct);
                  }}
                >
                  <div style={{ fontWeight: "bold" }}>
                    {acct.subscription_type}
                  </div>
                </Link>
              </div>
            ),
            action: (
              <div
                className="d-flex justify-content-around"
                style={{ width: 100 }}
              >
              {!this.props.isAzureView && (
              <div>
                {this.props.roleAccess < 0 ||
                !allowedRoles.includes(userRole) ||
                this.props.licensing.licenseName ===
                  process.env.REACT_APP_FREE_ORGANIZATION_LICENSE ||
                acct.subscription_status === "expired" ? (
                  <button
                    disabled
                    className="btn btn-link text-info btn-sm"
                    id="edit1"
                  >
                    <i className="mdi mdi-quadcopter font-size-18 text-darkblue"></i>
                  </button>
                ) : (
                  <>
                    <Link
                      to="#"
                      // className="btn btn-link mr-3 text-darkblue"
                      id="edit1"
                      title={
                        acct.status === "INACTIVE"
                          ? "Activate Account"
                          : "Rotate External ID"
                      }
                      onClick={() =>
                        this.setState({
                          ...this.state,
                          editAccountCode: acct.accountCode,
                          editRoleModal: true,
                        })
                      }
                    >
                      {acct.status === "INACTIVE" && acct.iamrole == null  ? (
                        <Button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InactiveAccountIcon />
                        </Button>
                      ) : (
                        <i className="mdi mdi-quadcopter font-size-18 text-darkblue"></i>
                      )}
                    </Link>
                  </>
                )}
              </div>
              )}
              <div>
                {this.props.roleAccess < 0 ||
                !allowedRoles.includes(userRole) ||
                this.props.licensing.licenseName ===
                  process.env.REACT_APP_FREE_ORGANIZATION_LICENSE ||
                acct.subscription_status === "expired" ||
                acct.status !== "ACTIVE" ? (
                  <button
                    disabled
                    className="btn btn-link text-info btn-sm"
                    id="edit1"
                  >
                    <i className="mdi mdi-pencil font-size-18 text-darkblue"></i>
                  </button>
                ) : (
                  <>
                    <Link
                      to="#"
                      // className="btn btn-link mr-3 text-darkblue"
                      id="edit1"
                      title="Update Account"
                      onClick={() =>
                        this.setState({
                          ...this.state,
                          editAcctModal: true,
                          editAccountCode: acct.accountCode,
                        })
                      }
                    >
                      <i className="mdi mdi-pencil font-size-18 text-darkblue"></i>
                    </Link>
                  </>
                )}
              </div>
              <div>
                {this.props.roleAccess < 0 ||
                !allowedRoles.includes(userRole) ||
                acct.subscription_status === "expired" ||
                acct.status !== "ACTIVE" ? (
                  <button
                    disabled
                    className="btn btn-link text-info btn-sm"
                    id="delete1"
                    title="Delete Account"
                  >
                    <i className="mdi mdi-trash-can font-size-18 text-danger"></i>
                  </button>
                ) : (
                  <>
                    <Link
                      to="#"
                      // className="btn btn-link text-danger"
                      id="delete1"
                      title="Delete Account"
                      disabled={this.props.roleAccess < 0}
                      onClick={() => this.setNotifyDelete(true, acct)}
                    >
                      <i className="mdi mdi-trash-can font-size-18 text-danger"></i>
                    </Link>
                  </>
                )}
              </div>
              </div>
            ),
          };
        }),
    };
    return (
      <React.Fragment>
        {this.renderSidePanel()}
        {this.state.isOpen && (
          <Modal 
            isOpen={this.state.isOpen} 
            size="lg" 
            centered
            toggle={this.closeModal}
          >
            <ModalHeader
              toggle={this.closeModal}
              style={{
                backgroundColor: "#F98125",
                margin: -1,
                display: "flex",
                alignItems: "center",
                minHeight: 56,
              }}
              close={
                <button
                  type="button"
                  aria-label="Close"
                  onClick={this.closeModal}
                  style={{
                    padding: 0,
                    margin: 0,
                    border: "none",
                    background: "transparent",
                    color: "#FFFFFF",
                    fontSize: 28,
                    fontWeight: 700,
                    lineHeight: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    opacity: 1,
                    boxShadow: "none",
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              }
            >
              <Typography color="#FFFFFF" variant="h6">
                {this.state.selectedAccountType === "AZURE"
                  ? "Pair Subscription"
                  : "Pair Account"}
              </Typography>
            </ModalHeader>
            <ModalBody style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden' }}>
              <div id="add-account-wizard-chrome" />
              {(this.state.addAccountTab === "2" ||
                this.state.currentStep === 1) && (
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={this.state.addAccountTab === '1' ? 'active' : ''}
                    onClick={() => this.toggleTab('1')}
                    style={{ cursor: 'pointer' }}
                  >
                    Add Account
                  </NavLink>
                </NavItem>
                {this.state.selectedAccountType === 'AWS' &&
                  this.state.showMultipleAccountsTab && (
                  <NavItem>
                    <NavLink
                      className={this.state.addAccountTab === '2' ? 'active' : ''}
                      onClick={() => this.toggleTab('2')}
                      style={{ cursor: 'pointer' }}
                    >
                      Add Multiple Accounts
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              )}
              <TabContent activeTab={this.state.addAccountTab}>
                <TabPane tabId="1">
                  <OrgAccount
                    handleAddAccountsModal={this.closeModal}
                    newAccountAdded={this.newAccountAdded}
                    onStepChange={this.handleStepChange}
                    onAccountTypeChange={this.handleAccountTypeChange}
                    initialAccountType={
                      this.props.isAzureView ? "AZURE" : "AWS"
                    }
                    wizardChromeActive={this.state.addAccountTab === "1"}
                    onSidePanelOpen={this.handleSidePanelOpen}
                    onAzureLighthouseJsonChange={
                      this.handleAzureLighthouseJsonChange
                    }
                    onAzureFetchDetailsComplete={
                      this.handleAzureFetchDetailsComplete
                    }
                  />
                </TabPane>
                {this.state.selectedAccountType === 'AWS' &&
                  this.state.addAccountTab === '2' && (
                  <TabPane tabId="2">
                    <MultipleAccountsForm 
                      ref={this.multipleAccountsFormRef}
                      organizations={this.props.accounts} 
                      closeModal={this.closeModal}
                      onAccountsAdded={this.handleAccountsAdded}
                      onStepChange={this.handleStepChange}
                    />
                  </TabPane>
                )}
              </TabContent>
            </ModalBody>
          </Modal>
        )}
        {(this.state.isOpen &&
          (this.state.addAccountTab === "1" || this.state.addAccountTab === "2") &&
          this.state.sidePanelOpen) && (
          <style>
            {`
              .modal.show {
                padding-right: 480px !important;
              }
              @media (max-width: 1400px) {
                .modal.show {
                  padding-right: 420px !important;
                }
              }
              @media (max-width: 1200px) {
                .modal.show {
                  padding-right: 380px !important;
                }
              }
              @media (max-width: 1024px) {
                .modal.show {
                  padding-right: 320px !important;
                }
              }
            `}
          </style>
        )}
        <Row>
          <Col lg={12}>
            <div style={{ overflowX: "auto", maxHeight: "400px" }}>
              <DataGridWrapper
                key={this.props.isAzureView ? "azure-accounts" : "aws-accounts"}
                searchTop
                searchBottom={false}
                hover={true}
                responsive={true}
                small
                entriesOptions={[10, 20, 30]}
                data={data}
                fullPagination
              />
            </div>
            <Legends />
          </Col>
        </Row>
        {this.state.modal_static && (
          <ViewAccountList
            modal_static={this.state.modal_static}
            closeModal={this.closeModal}
            accountCode={this.state.accountCode}
            accountNumber={this.state.accountNumber}
            userList={this.state.userList}
            key={`user-list-${this.state.accountCode}`}
          />
        )}

        {this.state.modal_addons && (
          <AddOnsManagement
            modal_addons={this.state.modal_addons}
            closeModal={this.closeModal}
            // accountCode={this.state.accountCode}
            // accountNumber={this.state.accountNumber}
            complianceAddOns={complianceAddOns || []}
            addOns={addOns || []}
            editAccount={editAcct}
            accounts={this.props.accounts}
            handleAddonsUpgrade={this.handleAddonsUpgrade}
          />
        )}

        {/* Rotate IAM Role */}
        <Modal isOpen={this.state.editRoleModal} size="lg" centered>
          <ModalHeader
            style={{ backgroundColor: "#F98125", margin: -1}}
          >
           <Typography color="#FFFFFF" variant="h6">
            {editAcct?.status === "ACTIVE" ? "Update IAM Role" : "Activate Account"}
          </Typography>
          </ModalHeader>
          <ModalBody>
            <UpdateIamRole
              externalId={this.props.organizations[0].externalid}
              selectedAccount={editAcct}
              addOns={addOns}
              closeModal={this.closeModal}
              key={editAcct?.accountCode}
            />
          </ModalBody>
        </Modal>
        {/* Update Account */}
        <Modal
          isOpen={this.state.editAcctModal}
          size="lg"
          centered
          toggle={this.closeModal}
        >
          <ModalHeader
            toggle={this.closeModal}
            style={{
              backgroundColor: "#F98125",
              margin: -1,
              display: "flex",
              alignItems: "center",
              minHeight: 56,
            }}
            close={
              <button
                type="button"
                aria-label="Close"
                onClick={this.closeModal}
                style={{
                  padding: 0,
                  margin: 0,
                  border: "none",
                  background: "transparent",
                  color: "#FFFFFF",
                  fontSize: 28,
                  fontWeight: 700,
                  lineHeight: 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  opacity: 1,
                  boxShadow: "none",
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            }
          >
            <Typography color="#FFFFFF" variant="h6">
                Update Account
            </Typography>
          </ModalHeader>
          <ModalBody
            style={{
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <UpdateAccount
              selectedAccount={editAcct}
              closeModal={this.closeModal}
              updateData={this.updateData}
            />
          </ModalBody>
        </Modal>
        {/* Delete account */}
        <Modal isOpen={this.state.notifyDelete} size="md" centered>
          <ModalHeader
            closeModal={this.closeModal}
            style={{ backgroundColor: "#F98125", margin: -1 }}
          >
            <Typography color="#FFFFFF" variant="h6">
              Delete Account
            </Typography>  
          </ModalHeader>
          <ModalBody>
            {this.state.notifyDeleteRow && (
              <>
                {[
                  {
                    name:
                      getAccountCloudType(this.state.notifyDeleteRow) === "AZURE"
                        ? "Subscription Name"
                        : "Account Name",
                    field: "accountName",
                  },
                  {
                    name:
                      getAccountCloudType(this.state.notifyDeleteRow) === "AZURE"
                        ? "Subscription ID"
                        : "Account Number",
                    field: "accountNumber",
                  },
                ].map((item) => {
                  return (
                    <div className="form-group row">
                      <label
                        htmlFor="isLicComplete"
                        className="col-sm-6 col-form-label"
                      >
                        {item.name}
                      </label>
                      <div className="col-sm-5">
                        {this.state.notifyDeleteRow[item.field]}
                      </div>
                    </div>
                  );
                })}
                Customer-enabled deletion is not available at the moment. Please
                email{" "}
                <a href="mailto:support.cloudcatcher@cloudnovatech.com">
                  support.cloudcatcher@cloudnovatech.com
                </a>{" "}
                to request deletion of this account.
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn w-lg btn-secondary"
              onClick={() => this.setNotifyDelete(false)}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
        {/* Modal to display Licensing Information */}
        <SubscriptionModal
          isOpen={this.state.isLicensingInfoOpen}
          toggle={this.closeLicensingInfoModal}
          handleUpgradeClick={this.handleUpgradeClick}
          accountInformation={this.state.accountInformation}
        />
        
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    pricingInfo,
    error: pricingInfoApiError,
    loading: pricingInfoApiLoading,
    accountNumber,
  } = state.pricingInfo;

  const { organizations } = state.acctList;

  const { postAccountConfigurationMessage, postAccountConfigurationError } =
    state.accountConfiguration;

  const { awsAccountPosting, postAwsAccMessage, postAwsAccError } =
    state.awsAcc;

  return {
    pricingInfo,
    pricingInfoApiError,
    pricingInfoApiLoading,
    accountNumber,
    organizations,
    orgLicensing: state.licensing,
    postAccountConfigurationMessage,
    postAccountConfigurationError,

    awsAccountPosting,
    postAwsAccMessage,
    postAwsAccError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetListOfAccts: () => {
      dispatch(getListOfAccts());
    },
    clearAllOrgAccountMessages: () => {
      dispatch(clearAllOrgAccountMessages());
    },
    getLicensePricingInfo: (accountNumber, subscription, orgCode) => {
      dispatch(getPricingInfo(accountNumber, subscription, orgCode));
    },
    clearAllAccountConfigurationMessages: () => {
      dispatch(clearAllAccountConfigurationMessages());
    },
    clearAllAwsAccMessages: () => {
      dispatch(clearAllAwsAccMessages());
    },
    dispatchClearOrganizationalUnits: () => {
      dispatch(clearOrganizationalUnits());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDetailPolicy);
